/**
 * Extrai a garantia do envelope `ResponseFrameResource` retornado pelo telli.
 *
 * O telli serializa o payload sob o campo `resource` (NAO `data`) e coloca o
 * `errorCode` no top-level do envelope. Ler `response.data.data` (campo
 * inexistente) faz a garantia sumir da tela — retornando sempre `null`.
 */
export const parseGuaranteesResponse = (response: any) =>
  response?.data?.errorCode ? null : response?.data?.resource ?? null;
